import './CardContainer.css';
import React from 'react';
import { clsx } from 'clsx';

const CardContainer = ({ children, className = '' }) => {
  return <div className={clsx('card p-4', className)}>{children}</div>;
};

export default CardContainer;
